import { createReducer } from 'reduxsauce';

import { UnsafeReturnType } from '../types';
import { IQuarantineState, quarantineTypes } from './types';
import * as quarantineActions from './actions';

/* ------------- Types and Action Creators ------------- */

/* ------------- Initial State ------------- */
const INITIAL_STATE: IQuarantineState = {
  quarantines: [],
};

/* ------------- Selectors ------------- */

/* ------------- Reducers ------------- */
interface IActionHandler<T> {
  (state: IQuarantineState, action: UnsafeReturnType<T>): IQuarantineState;
}

const getQuarantines: IActionHandler<typeof quarantineActions['getQuarantines']> = (state, { payload }) => ({
  ...state,
});

const getUserHealthQuarantineById: IActionHandler<typeof quarantineActions['getUserHealthQuarantineById']> = (
  state,
  { payload },
) => ({
  ...state,
});

const getUserLocationQuarantineById: IActionHandler<typeof quarantineActions['getUserLocationQuarantineById']> = (
  state,
  { payload },
) => ({
  ...state,
});

const getUserContactQuarantineById: IActionHandler<typeof quarantineActions['getUserContactQuarantineById']> = (
  state,
  { payload },
) => ({
  ...state,
});

/* ------------- Hookup Reducers To Types ------------- */
const HANDLERS = {
  [quarantineTypes.GET_QUARANTINES]: getQuarantines,
  [quarantineTypes.GET_USER_HEALTH_QUARANTINE_BY_ID]: getUserHealthQuarantineById,
  [quarantineTypes.GET_USER_LOCATION_QUARANTINE_BY_ID]: getUserLocationQuarantineById,
  [quarantineTypes.GET_USER_CONTACT_QUARANTINE_BY_ID]: getUserContactQuarantineById,
};

const quarantineReducer = createReducer<IQuarantineState>(INITIAL_STATE, HANDLERS);

/* ------------- export ------------- */
export { quarantineReducer, quarantineTypes, quarantineActions };
